<template>
	<template v-if="item?.id">
		<BaseMetaSeo :data="item" />
		<div class="cd-main">
			<div class="cd-row wrapper" :class="{'loading': loadingItemData}">
				<div class="cd-col1">
					<!-- Item info -->
					<div class="cd-header" :class="{'blur': xxxVisibility == true}">
						<CmsBreadcrumbs :items="item.breadcrumbs" mode="catalogDetail" />
						<template v-if="item.type == 'advanced'">
							<h1 v-if="item.primary_product_data && !advancedItem" class="cd-title">{{ item.seo_h1 }}</h1>
							<h1 v-if="item.type_config" class="cd-title advanced">
								<template v-for="(varTitle, key) in item.type_config" :key="key">
									<span v-if="advancedItem && advancedItem == key"
										>{{ item.seo_h1 }}<template v-if="varTitle.title_extra">, {{ varTitle.title_extra }}</template></span
									>
								</template>
							</h1>
						</template>
						<template v-else>
							<h1 class="cd-title" v-if="item.seo_h1">{{ item.seo_h1 }}</h1>
						</template>

						<div class="cd-info">
							<div v-if="item.type == 'advanced'" class="cd-code">
								<template v-if="item.primary_product_data && !advancedItem">
									<strong class="label">{{ labels.get('id') }}:</strong> <span>{{ item.primary_product_data.code }}</span>
								</template>
								<template v-if="item.type_config">
									<strong class="label">{{ labels.get('id') }}: </strong>
									<template v-for="(varCode, key) in item.type_config" :key="key">
										<span v-if="advancedItem && advancedItem == key">
											<template v-if="item.primary_product_data">{{ item.primary_product_data.code }}</template>
											<template v-if="varCode.code_extra">, {{ varCode.code_extra }}</template>
										</span>
									</template>
								</template>
							</div>
							<div v-else class="cd-code">
								<div>
									<span class="label">{{ labels.get('id') }}:</span> <span>{{ item.code }}</span>
								</div>
							</div>

							<ClientOnly>
								<LazyBaseFeedbackRatesWidget v-if="item?.feedback_rate_widget && item?.feedback_rate_widget?.rates_votes > 0" :data="item.feedback_rate_widget" v-slot="{stars}">
									<div class="cd-avarage-rate-section">
										<span class="cp-rate" v-html="stars" />
										<div class="cd-rate-average comments-count catalog-comment-count">
											<span>{{ Number(item.feedback_rate_widget.rates).toFixed(1) }}</span>
										</div>
										<div @click="mobileBreakpoint ? flyoutCommentActive('comment') : scrollTo('#tab3', {offset: 50})" class="cd-comments-link cd-tab-flyout-btn">{{ labels.get('send_review') }}</div>
									</div>
								</LazyBaseFeedbackRatesWidget>
							</ClientOnly>
						</div>
					</div>

					<!-- Images -->
					<div class="cd-images">
						<template v-if="item?.all_images?.length">
							<div v-if="xxxVisibility == true" @click="verificationXXX('url', item?.url_without_domain);" class="cd-xxx-img-info">
								<BaseCmsLabel code="xxx_img_info" tag="span" />
								<div @click="verificationXXX()" class="cd-xxx-img-btn verification_xxx_btn"><BaseCmsLabel code="xxx_img_btn" /></div>
							</div>
							<div class="cd-hero-image" :class="{'xxx': xxxVisibility == true}">
								<BaseUiSwiper
									class="cd-hero-slider"
									:options="{
											observer: true,
											slidesPerView: 1,
											slidesPerGroup: 1,
											pagination: {
												enabled: true
											},
											navigation: {
												enabled: false
											},
											breakpoints: {
												980: {
													pagination: false
												}
											}
										}"
									:thumbs-swiper="thumbsSwiper"
									:init-timeout="500">
									<template v-for="(file, index) in item.all_images" :key="index">
										<BaseUiSwiperSlide v-if="file.file_thumb?.thumb" class="cd-hero-slide" @mouseenter="activeZoom(file?.file_thumb_zoom?.thumb, index)" @mousemove="zoomOnMove($event, index)" @mouseleave="resetZoom">
											<div @click="openGallery(index)">
												<BaseUiImage loading="lazy" :data="file?.file_thumb" default="/images/no-image-640x640.webp" />
												<div v-if="zoomIndex === index && zoom && file.zoom_available == true" class="cd-hero-zoom" :style="zoomedImageStyle"></div>

												<!-- image state badge -->
												<span v-if="file.state == 'd'" class="badge-bottom-left btn-image-state" :class="{'special': item?.check_lists?.[webcatalog3D]}"><BaseCmsLabel code="condition_images_badge" tag="span" /></span>
											</div>
										</BaseUiSwiperSlide>
									</template>
								</BaseUiSwiper>

								<!-- Badges info -->
								<CatalogWidgetDetailBadgesHeroImage :item="item" :advancedItem="advancedItem" />

								<!-- 3d button -->
								<div v-if="item?.check_lists?.[webcatalog3D]" @click="bus.event = 'model-view'" class="badge-bottom-left btn-model-view"><BaseCmsLabel code="view_3d" tag="span" /></div>
							</div>

							<ClientOnly>
								<div v-if="item?.all_images?.length > 1" class="cd-thumbs cd-thumbs-slider" :class="{'xxx': xxxVisibility == true, 'special': item?.all_images?.length < 7}">
									<BaseUiSwiper
										:options="{
											observer: true,
											spaceBetween: 10,
											slidesPerView: 6,
											watchSlidesProgress: true
										}"
										@init="setThumbsSwiper"
										:init-timeout="500">
										<template v-for="(thumb, index) in item?.all_images" :key="index">
											<BaseUiSwiperSlide class="cd-thumb" v-if="thumb.file_thumb_small?.thumb">
												<BaseUiImage loading="lazy" :data="thumb?.file_thumb_small" default="/images/no-image-120.webp" />
											</BaseUiSwiperSlide>
										</template>
									</BaseUiSwiper>
								</div>
							</ClientOnly>
						</template>
						<template v-else>
							<img loading="lazy" src="/images/no-image-650.webp" :title="item.seo_h1" :alt="item.seo_h1" />
						</template>
					</div>

					<!-- Badges info -->
					<ClientOnly>
						<LazyCatalogWidgetDetailBadges v-if="item?.badges?.length" :item="item" />
					</ClientOnly>
				</div>

				<div class="cd-col2">
					<!-- Price -->
					<div class="cd-price-container">
						<LazyCatalogWidgetDetailPrice v-if="item?.price_custom" :item="item" :advancedItem="advancedItem" />

						<ClientOnly>
							<!-- Manufacturer -->
							<div v-if="item.manufacturer_main_image" class="cd-brand">
								<NuxtLink :to="item.manufacturer_url_without_domain">
									<BaseUiImage loading="lazy" :src="item.manufacturer_main_image_upload_path" width="110" height="45" default="/images/no-image-50.webp" :alt="item.manufacturer_title" />
								</NuxtLink>
							</div>
						</ClientOnly>
					</div>

					<!-- Special price -->
					<template v-if="item.is_available">
						<div v-if="item.price_custom_prices_cart && item.price_custom_prices_cart_expire" class="cd-conf-price-section">
							<div class="cd-conf-price">
								<BaseCmsLabel code="configured_price" tag="span" class="cd-conf-current-price-label" />
								<span class="cd-current-price red"><BaseUtilsFormatCurrency :price="item.price_custom_prices_cart" /></span>
							</div>
							<div class="cd-conf-price-timer">
								<BaseCmsLabel code="conf_price_valid" />
								<span class="cd-conf-price-timer-bottom">
									<ClientOnly>
										<span class="countdown" v-html="countdownFormatted"></span>
									</ClientOnly>
									<a class="cd-conf-price-remove" @click="dynamicPriceRemove(item)" href="javascript:void(0)">remove</a>
								</span>
							</div>

							<div v-if="labels.get('conf_price_note') != 'conf_price_note'" class="cd-conf-price-note"><BaseCmsLabel code="conf_price_note" tag="span" /></div>
						</div>
						<template v-else-if="item.extra_price_cart_dynamicprice != 0 && item.extra_price_dynamicprice != 0">
							<div class="cd-conf-price-label" :class="{'active': !dynamicPriceActive}">
								<span><BaseCmsLabel code="conf_price_label" />&nbsp;</span>
								<a href="javascript:void(0)" @click="dynamicPriceSelect(item)"><BaseCmsLabel code="conf_price" /></a>
							</div>
							<template v-if="item.extra_price_mode_dynamicprice">
								<div v-if="item.extra_price_mode_dynamicprice == 'show_form_our'" class="cd-conf-price-label cd-dynamicprice-desc" :class="{'active': dynamicPriceActive}"><BaseCmsLabel code="dynamicprice_desc_lowest_price" tag="span" /></div>
								<div v-else-if="item.extra_price_mode_dynamicprice == 'show_form_limit'" class="cd-conf-price-label cd-dynamicprice-desc" :class="{'active': dynamicPriceActive}"><BaseCmsLabel code="dynamicprice_desc_lowest_price" tag="span" /></div>
							</template>
						</template>
					</template>

					<ClientOnly>
						<!-- Loyalty box -->
						<CatalogWidgetDetailLoyaltyBox :item="item" :advancedItem="advancedItem" />

						<!-- Status info -->
						<CatalogWidgetDetailStatus />

						<!-- Energy info -->
						<LazyCatalogWidgetDetailEnergy v-if="item.attributes?.length" :attributeItem="item.attributes" :energyImage="item?.energy_image_upload_path_thumb_energy" />

						<!-- Charger info -->
						<LazyCatalogWidgetCharger v-if="item.attributes?.length" :item="item" />
					</ClientOnly>

					<CatalogWidgetDetailConfigurabile :item="item" />

					<ClientOnly>
						<!-- Services -->
						<CatalogWidgetDetailServices :item="item" />

						<!-- Add to cart -->
						<div ref="addToCart">
							<CatalogWidgetDetailAddToCart :item="item" :advancedItem="advancedItem" />
						</div>
					</ClientOnly>

					<!-- Info labels -->
					<div v-if="labels.get('return_policy_value') != 'return_policy_value'" class="cd-return-policy">
						<span v-html="labels.get('return_policy_value')"></span>&nbsp;
						<div v-if="labels.get('return_policy_info') != 'return_policy_info'" @click="flyoutLabel(labels.get('return_policy_flyout_title'), labels.get('return_policy_info'))" class="cd-return-policy-link" v-html="labels.get('return_policy_link')"></div>
					</div>
					<div v-if="item?.seller_code == '9999' && labels.get('companies_value') != 'companies_value'" class="cd-return-policy cd-companies" :class="{'special': labels.get('return_policy_value') != 'return_policy_value'}">
						<span v-html="labels.get('companies_value')"></span>&nbsp;
						<div v-if="labels.get('companies_info') != 'companies_info'" class="cd-return-policy-link" v-html="labels.get('companies_info')"></div>
					</div>

					<!-- Shippings -->
					<CatalogWidgetDetailShipping :item="item" />

					<!-- Seller -->
					<CatalogWidgetDetailSeller :item="item" />

					<div v-if="labels.get('shop_extra_info_pdp') != 'shop_extra_info_pdp'" class="cd-s-extra-info s-extra-info cd-flyout-btn" @click="flyoutLabel(labels.get('shop_extra_info_flyout_title_pdp'), labels.get('shop_extra_info_flyout_content_pdp'))">
						<span v-html="labels.get('shop_extra_info_pdp')"></span>
					</div>
				</div>
			</div>

			<!-- Related products -->
			<ClientOnly>
				<CatalogProductsWidget
					:fetch="{related_code: 'related', related_item_id: item.id, related_widget_data: item.related_widget_data, only_available: true, limit: 10, always_to_limit: true, response_fields: config.catalog.productsResponseFields}"
					:mode="item?.manufacturer_code == 'dyson-9231' ? 'cd_p1_brand_dyson' : 'cd_p1'"
					thumb-preset="catalogEntry"
					v-slot="{items}"
					@loadProductsWidget="loadProductsWidget">
					<div class="cd-related-products wrapper" v-if="items?.length">
						<div class="cd-related-title">{{ labels.get('related_products') }}</div>
						<div class="cd-related-products-slider">
							<BaseUiSwiper
								name="cd-related"
								:options="{
									slidesPerView: 4,
									slidesPerGroup: 4,
									spaceBetween: 20,
									enabled: false,
									loop: false,
									breakpoints: {
										1600: {
											slidesPerView: 5,
											slidesPerGroup: 5,
											enabled: true,
										},
										1250: {
											slidesPerView: 4,
											slidesPerGroup: 4,
											enabled: true,
										},
										980: {
											enabled: true,
										},
									}
								}">
								<BaseUiSwiperSlide v-for="(item, index) in items" :key="item.id">
									<CatalogIndexEntry :item="item" categoryListData="PDP" :index="index" mode="slider" />
								</BaseUiSwiperSlide>
							</BaseUiSwiper>
						</div>
					</div>
				</CatalogProductsWidget>
			</ClientOnly>

			<!-- Content -->
			<CatalogWidgetDetailContent v-if="item" :item="item" />

			<ClientOnly>
				<CatalogProductsWidget
					:fetch="{related_code: 'related', related_item_id: item.id, related_widget_data: item.related_widget_data, only_available: true, limit: 10, always_to_limit: true, response_fields: config.catalog.productsResponseFields}"
					:mode="item?.manufacturer_code == 'dyson-9231' ? 'cd_p2_brand_dyson' : 'cd_p2'"
					thumb-preset="catalogEntry"
					v-slot="{items}"
					@loadProductsWidget="loadProductsWidget">
					<div class="cd-related-products special wrapper" v-if="items?.length">
						<div class="cd-related-title">{{ labels.get('related_products') }}</div>
						<div class="cd-related-products-slider">
							<BaseUiSwiper
								name="cd-related2"
								:options="{
									slidesPerView: 4,
									slidesPerGroup: 4,
									spaceBetween: 20,
									enabled: false,
									loop: false,
									breakpoints: {
										1600: {
											slidesPerView: 5,
											slidesPerGroup: 5,
											enabled: true,
										},
										1250: {
											slidesPerView: 4,
											slidesPerGroup: 4,
											enabled: true,
										},
										980: {
											enabled: true,
										},
									}
								}">
								<BaseUiSwiperSlide v-for="(item, index) in items" :key="item.id">
									<CatalogIndexEntry :item="item" categoryListData="PDP" :index="index" mode="slider" />
								</BaseUiSwiperSlide>
							</BaseUiSwiper>
						</div>
					</div>
				</CatalogProductsWidget>
			</ClientOnly>

			<CmsShare />
		</div>

		<ClientOnly>
			<div class="cd-fixed-bar" :class="{'visible': !isVisible}">
				<div class="cd-bar-wrapper">
					<div v-if="item.main_image_upload_path" class="cd-fixed-img"><BaseUiImage loading="lazy" :data="item?.main_image_upload_path_thumb" default="/images/no-image-50.webp" /></div>
					<template v-if="item.type == 'advanced'">
						<div v-if="item.primary_product_data && !advancedItem" class="cd-title">{{ item.seo_h1 }}</div>
						<div v-if="item.type_config" class="cd-title advanced">
							<template v-for="(varTitle, key) in item.type_config" :key="key">
								<span v-if="advancedItem && advancedItem == key"
									>{{ item.seo_h1 }}<template v-if="varTitle.title_extra">, {{ varTitle.title_extra }}</template></span
								>
							</template>
						</div>
					</template>
					<template v-else>
						<div class="cd-title">{{ item.seo_h1 }}</div>
					</template>
					<CatalogWidgetDetailPrice :item="item" :advancedItem="advancedItem" mode="fixedBar" />
					<CatalogWidgetDetailAddToCart :item="item" mode="fixedBar" />
				</div>
			</div>

			<!-- 3d item view -->
			<CatalogWidgetDetailModelView v-if="bus.event == 'model-view'" :item="item" />
			<Teleport to="body">
				<LazyBaseThemeUiModal v-if="Object.keys(activeModals()).includes('gallery-modal')" name="gallery-modal" :zoom="true" />
			</Teleport>
		</ClientOnly>
	</template>
</template>

<script setup>
	const webshop = useWebshop();
	const auth = useAuth();
	const gtm = useGtmBB();
	const route = useRoute();
	const {getLastUrlSegment} = useUrl();
	const endpoints = useEndpoints();
	const config = useAppConfig();
	const labels = useLabels();
	const {generateThumbs} = useImages();
	const {emit, bus} = useEventBus();
	const {formatDate} = useText();
	const {formatCurrency} = useCurrency();
	const {scrollTo, onElementVisibility} = useDom();
	const {open: openModal, activeModals} = useModal();
	const item = useState('product');
	let loadingItemData = ref(false);
	let dynamicPriceDate = ref(null);
	const confShopingCartCode = ref(null);
	const origin = config.host == 'https://www.bigbang.si' || config.host == 'https://beta.bigbang.si' ? true : false;
	//const webcatalog = origin ? '?check_lists=webcatalog_157271,webcatalog_157270,webcatalog_201949,webcatalog_1219026' : '?check_lists=webcatalog_157271,webcatalog_157270,webcatalog_201949,webcatalog_2225499';
	//const webcatalog3D = origin ? 'webcatalog_1219026' : 'webcatalog_2225499';
	const webcatalog = '?check_lists='+config.catalog.fetch.check_lists;
	const webcatalog3D = 'webcatalog_3d-ar';

	function openGallery(index) {
		const images = (item.value?.all_images?.length) ? item.value.all_images : [];
		if(!images?.length) return;
		openModal('gallery-modal', {
			startIndex: index,
			items: images.map(item => item.file_thumb),
		});
	}

	// generate thumbnails
	async function imageThumbs() {
		return Promise.all([
			generateThumbs({
				data: item.value,
				preset: 'catalogDetail'
			}),
			generateThumbs({
				data: item.value,
				preset: 'catalogDetailExtra'
			}),
		]);
	}

	await imageThumbs();

	//rwd
	const {mobileBreakpoint, tabletBreakpoint} = inject('rwd');

	//zoom on hover
	let zoom = ref(false);
	let zoomImage = ref(null);
	let zoomIndex = ref(null);
	let zoomScale = ref(1);
	let zoomedImageStyle = ref('');

	function activeZoom(image, index) {
		if(!tabletBreakpoint.value) {
			zoom.value = true;
			zoomImage.value = config.host + image;
			zoomIndex.value = index;
		}
	}
	function zoomOnMove(event, index) {
		if(zoom.value == true && zoomIndex.value === index && zoomImage.value) {
			const container = event.currentTarget;
			if(container) {
				const { left, top, width, height } = container.getBoundingClientRect();
				const mouseX = event.clientX - left;
				const mouseY = event.clientY - top;

				zoomScale.value = 1.4;
				const backgroundImage = `white url("${zoomImage.value}")`;
				zoomedImageStyle.value = `
					background: ${backgroundImage};
					transform: scale(${zoomScale.value});
					transform-origin: ${(mouseX / width) * 100}% ${(mouseY / height) * 100}%;
				`;
			}
		}
	};
	function resetZoom() {
		zoom.value = false;
		zoomImage.value = null;
		zoomIndex.value = null;
		zoomScale.value = 1;
		zoomedImageStyle.value = '';
	};

	//loyalty
	const isLoyalty = computed(() => {
		const user = auth.getUser();
		if(user?.loyalty_code) {
			return true;
		} else {
			return false;
		}
	});
	const priceSaved = computed(() => {
		if (!item.value) return 0;

		if (item.value.selected_price == 'recommended' && (item.value.discount_percent_custom > 0 || item.value.price_custom < item.value.basic_price_custom) && (isLoyalty.value == true && item.value.loyalty_price_custom) && item.value.loyalty_price_custom < item.value.price_custom) {
			return item.value.price_custom - item.value.loyalty_price_custom;
		} else if ((isLoyalty.value == true && item.value.loyalty_price_custom) && item.value.price_custom > item.value.loyalty_price_custom) {
			return item.value.basic_price_custom - item.value.loyalty_price_custom;
		} else {
			return item.value.basic_price_custom - item.value.price_custom;
		}
	});

	//configurable
	const ep = endpoints.get('_get_hapi_catalog_offer');
	let mountedTimeout;
	onMounted(async () => await mounted());
	watch(item, async () => await mounted());

	async function mounted() {
		clearInterval(updateDynamicPriceTimer);
		clearTimeout(mountedTimeout);
		await imageThumbs();
		mountedTimeout = setTimeout(async () => {
			/*
			if(item.value.type == 'configurable') {
				loadingItemData.value = true;
				const urlParams = new URLSearchParams(window.location.search);
				const searchQ = urlParams.get('search_q') ? urlParams.get('search_q') : item.value.primary_product_data?.code;

				for (const key in item.value.type_config.product_data) {
					const obj = item.value.type_config.product_data[key];
					if (obj.code === searchQ) {
						confShopingCartCode.value = obj.offer_shopping_cart_code;
						break;
					}
				}

				if(confShopingCartCode.value) {
					const confEp = ep.replace('%CODE%', confShopingCartCode.value);
					await useApi(`${confEp + webcatalog}`, {
						method: 'GET',
					}).then(async (res) => {
						item.value = res.data;

						// generate thumbnails
						await imageThumbs();
					});
				}

				emit('confAvailableClass');

				loadingItemData.value = false;
			}
			*/

			//dynamic price countdown
			dynamicPriceDate.value = item.value?.price_custom_prices_cart_expire;
			if (dynamicPriceDate.value) {
				setInterval(updateDynamicPriceTimer, 1000);
			}

			//gtm
			gtm.pageView({
				url: item?.value?.url || '',
				title: item?.value?.title || '',
			});

			gtm.viewItem({
				'item_name': item.value?.title || '',
				'item_id': item.value?.code || '',
				'item_id2': item.value?.id || '',
				'price': (item?.value?.price_custom) ? parseFloat(item.value.price_custom).toFixed(2) : 0,
				'discount_amount': (priceSaved.value) ? parseFloat(priceSaved.value).toFixed(2) : 0,
				'item_discount_percentage': (item.value?.discount_percent) ? item.value.discount_percent : 0,
				'item_brand': (item.value?.manufacturer_title) ? item.value.manufacturer_title : '',
				'item_categories': (item.value?.category_hierarchy_full) ? item.value.category_hierarchy_full : '',
				'item_reviews_no': (item.value?.feedback_rate_widget?.rates_votes) ? item.value.feedback_rate_widget.rates_votes : 0,
				'item_reviews_rating': (item.value?.feedback_rate_widget?.rates_sum) ? item.value.feedback_rate_widget.rates_sum : 0,
			});
		},500);

		//4th vision
		useHead({
			script: [
				{
					src: config.host == 'https://www.bigbang.si' ? labels.get('prod_3dviewer') : labels.get('dev_3dviewer'),
					type: 'module',
					id: '4thvision',
					async: true,
				},
			],
		});
	}

	onUnmounted(() => {
		clearInterval(updateDynamicPriceTimer);
		clearTimeout(mountedTimeout);
		removeScript();
	});

	//remove script
	function removeScript() {
		// Find the script by id and remove it
		const script = document.getElementById('4thvision');
		if (script) {
			script.remove();
		}
	}

	//image slider
	const thumbsSwiper = ref(null);
	const setThumbsSwiper = (swiper) => {
		thumbsSwiper.value = swiper;
	};

	//open mobile flyout comment
	function flyoutCommentActive() {
		emit('flyoutCommentMobile', {'comment': true});
	}

	//dynamic price
	let dynamicPriceActive = ref(false);
	let dynamicPriceCartPriceActive = ref(false);
	async function dynamicPriceSelect(item) {
		if(item?.extra_price_mode_dynamicprice === 'show_price') {
			loadingItemData.value = true;
			var itemPriceIntg = parseFloat(item.extra_price_dynamicprice);
			const options = {
				prices_cart: {
					code: item.shopping_cart_code,
					category: 'dynamicprice',
					price: itemPriceIntg
				}
			}
			await useApi(`${endpoints.get('_post_hapi_customer')}`, {
				method: 'POST',
				body: options,
			}).then(async (res) => {
				dynamicPriceCartPriceActive.value = true;
				await webshop.fetchCart();
			})

			dynamicPriceActive.value = false;
		} else {
			dynamicPriceActive.value = true;
		}
	}

	async function dynamicPriceRemove(item) {
		loadingItemData.value = true;
		const options = {
			remove_prices_cart: item.shopping_cart_code,
		}
		await useApi(`${endpoints.get('_post_hapi_customer')}`, {
			method: 'POST',
			body: options,
		}).then(async (res) => {
			dynamicPriceCartPriceActive.value = false;
			await webshop.fetchCart();
		})

		dynamicPriceActive.value = false;
		loadingItemData.value = false;
	}

	watch(
		() => dynamicPriceCartPriceActive.value,
		async (newValue) => {
			const url = getLastUrlSegment(route.path).split('-');
			const productId = url[url.length - 1];
			const slug = url.slice(0, -2).join('-');
			const fetchOptions = {
				item_id: productId,
				item_slug: slug,
			};

			const urlParams = Object.keys(fetchOptions).length ? '?' + new URLSearchParams(fetchOptions).toString() : '';
			await useApi(`${endpoints.get('_get_hapi_catalog_product')}${urlParams}`, {
				method: 'GET',
			})
			.then(async (res) => {
				item.value = res.data;
				dynamicPriceDate.value = res.data?.price_custom_prices_cart_expire;

				if (dynamicPriceDate.value && process.client) {
					setInterval(updateDynamicPriceTimer, 1000);
				}

				// generate thumbnails
				await imageThumbs();
			})

			loadingItemData.value = false;
		}
	)

	//dynamic price countdown
	const remainingTime = ref(0);
	const countdownFormatted = computed(() => {
		const targetTime = new Date(dynamicPriceDate.value * 1000);
		const currentTime = new Date();
		remainingTime.value = Math.max(0, Math.floor((targetTime - currentTime) / 1000));

		const hours = Math.floor(remainingTime.value / 3600);
		const minutes = Math.floor((remainingTime.value % 3600) / 60);
		const seconds = remainingTime.value % 60;

		return `
			<span><span class="value semi-bold hours">${hours}</span><span class="frame"> ur </span></span>
			<span><span class="value semi-bold">${minutes}</span><span class="frame"> min </span></span>
			<span><span class="value semi-bold">${seconds}</span><span class="frame"> s</span></span>
		`;
	});

	const updateDynamicPriceTimer = () => {
		remainingTime.value = Math.max(0, remainingTime.value - 1);
	};

	//advanced items
	let advancedItem = ref(null)
	let advancedItemTitle = ref(null)

	watch(
		() => bus.value,
		async (newValue) => {
			//advanced item
			if (newValue.event === 'advancedItem') {
				advancedItem.value = newValue.data?.advancedItem;
				advancedItemTitle.value = newValue.data?.advancedItemTitle;
			}

			//conf item
			if(newValue.event === 'confItem') {
				loadingItemData.value = true;
				const offerShoppingCartCode = newValue.data[0] ? newValue.data[0] : confShopingCartCode.value;
				let ep = endpoints.get('_get_hapi_catalog_offer');
				ep = ep.replace('%CODE%', offerShoppingCartCode);

				await useApi(`${ep + webcatalog}`, {
					method: 'GET',
				}).then(async res => {
					if(res.data?.id) {
						item.value = res.data;

						//update url item code
						const url = new URL(window.location.href);
						const searchParams = new URLSearchParams(url.search);

						if(item.value?.code) searchParams.set('search_q', item.value.code);
						const confCode = searchParams.toString() ? `?${searchParams}` : '';
						window.history.replaceState({}, '', `${url.pathname}${confCode}`);

						// generate thumbnails
						await imageThumbs();
						emit('confAvailableClass');
					} else {
						return navigateTo('/404/');
					}
				});


				loadingItemData.value = false;
			}

			//offer item
			if(newValue.event === 'selectOffer') {
				loadingItemData.value = true;
				const offerShoppingCartCode = newValue.data?.shopping_cart_code ? newValue.data.shopping_cart_code : confShopingCartCode.value;
				let ep = endpoints.get('_get_hapi_catalog_offer');
				ep = ep.replace('%CODE%', offerShoppingCartCode);

				await useApi(`${ep + webcatalog}`, {
					method: 'GET',
				}).then(async res => {
					if(res.data?.id) {
						item.value = res.data;
						await imageThumbs();
					} else {
						return navigateTo('/404/');
					}
				});

				loadingItemData.value = false;
			}
		}
	);

	//XXX verification
	let xxxVisibility = ref(item?.value?.xxx);
	function verificationXXX(title, value) {
		emit('xxx', {'title': title, 'value': value});
	}

	function hasCookie(cookieName) {
		if (typeof document !== 'undefined' && item?.value?.xxx) {
			const cookies = document.cookie.split(';');
			for (let i = 0; i < cookies.length; i++) {
				const cookie = cookies[i].trim();
				if (cookie.startsWith(cookieName + '=')) {
					xxxVisibility.value = false;
					return true;
				} else {
					xxxVisibility.value = true;
				}
			}
		}
		return false;
	}

	onMounted(() => {
		hasCookie('xxx_verification');
	});

	watch(
		() => bus?.value,
		() => {
			if(bus.value?.event == 'xxx_verificated') {
				hasCookie('xxx_verification');
				xxxVisibility.value = false;
			}
		}
	);

	//fixed bar
	const addToCart = ref(null);
	const {isVisible} = onElementVisibility({
		target: addToCart,
	});

	//flyout content
	function flyoutLabel(title, content) {
		emit('flyoutUpdate', {'flyout_title': title ? title : null, 'flyout_content': content ? content : null});
	}

	//gtm
	function loadProductsWidget(value) {
		if(value.items.length) {
			gtm.viewItemList(value.items, value.data);
		}
	}
</script>

<style lang="less">
	.page-catalog-detail{
		#ib-button-messaging.special{bottom: 185px!important;}
		#eye-catcher-container.special .ib-eye-catcher__content-container{bottom: 185px!important;}

		@media (max-width: @m){
			#ib-button-messaging{bottom: 75px!important;}
			#eye-catcher-container .ib-eye-catcher__content-container{bottom: 75px!important;}
		}
	}
	.modal-active #eye-catcher-container{display: none!important;}
</style>

<style lang="less" scoped>
	:deep(.gallery-modal){
		z-index: 99999;
		.base-modal-gallery-thumbs{
			width: 195px; padding: 20px 20px 20px 50px;
			@media (max-width: 1200px){width: 100%; padding: 10px;}
		}
		.base-modal-gallery-thumbs-items{gap: 1px;}
		.base-modal-gallery-thumbs-item{
			border-radius: 0; border: 1px solid transparent;
			&.active{border: 1px solid @blue;}
		}

		.base-modal-gallery-main{
			padding-left: 210px;
			@media (max-width: 1200px){padding: 0;}
		}
		.swiper-container img{max-width: 70%;}

		.base-modal-toolbar{
			top: 5%; right: 3%;
			@media (max-width: 1200px){top: 15px; left: 15px; right: 15px; display: flex; flex-direction: row-reverse; gap: 10px;}
		}
		.base-modal-toolbar-item{
			border-radius: 0; border: 1px solid #e0e8ee; margin: -1px 0 0 0; width: 50px; height: 50px; background: #fff;
			@media (max-width: 1200px){
				width: 40px; height: 40px;
				svg{width: 40%;}
			}
		}
		.base-modal-toolbar-close{
			border: 0; background: #E21937; font-weight: bold;
			@media (max-width: 1200px){margin-left: auto;}
			svg{display: none;}
			&:before{
				.icon-x(); font: 22px/1 @fonti; color: #fff;
				@media (max-width: 1200px){font-size: 18px;}
			}
		}
		.base-modal-gallery-nav{
			left: 21%; right: 10%;
			@media (max-width: @l){right: 8%;}
			@media (max-width: 1200px){left: 5px; right: 5px;}
		}
		.base-modal-gallery-nav-btn{
			svg{display: none;}
			&:before{.icon-arrow(); font: 40px/1 @fonti;
				@media (max-width: 1200px){font-size: 15px;}
			}
			&:hover{color: @blue;}
			@media (max-width: 1200px){width: 40px; height: 40px; background: #fff; box-shadow: 0 2px 30px #00254533;}
		}
	}

	.cd-main{position: relative;}
	.cd-row{
		display: flex; margin-top: 20px; margin-bottom: 60px;
		&.loading .cd-col2{
			pointer-events: none; position: relative;
			&:before{.pseudo(auto,auto); background: rgba(255,255,255,0.5); top: -1px; bottom: -1px; left: -1px; right: -1px; z-index: 111; opacity: 1; .transition(opacity);}
		}

		@media (max-width: @t){margin-top: 15px; margin-bottom: 50px;}
		@media (max-width: @m){display: block; margin-top: 10px; margin-bottom: 25px;}
		@media (max-width: @ms){display: block; margin-top: 10px; margin-bottom: 25px;}
	}
	.cd-col1{
		flex-shrink: 0; width: 780px; margin-right: 140px;

		@media (max-width: @l){width: 650px; margin-right: 60px;}
		@media (max-width: @t){width: 460px; margin-right: 30px;}
		@media (max-width: @m){flex-shrink: unset; width: calc(~"100% - -30px"); margin: 0 0 0 -15px; border-bottom: 1px solid @borderColor;}
	}
	.cd-header{
		margin-bottom: 20px;
		&.blur{
			.bc-short, .cd-title, .cd-code{filter: blur(5px);}
		}

		@media (max-width: @t){margin-bottom: 15px;}
		@media (max-width: @m){margin: 0 15px 12px;}
	}
	.cd-title{
		font-size: 20px; line-height: 1.2; color: @textColor; padding: 0;

		@media (max-width: @t){font-size: 17px; line-height: 1.4;}
	}
	.cd-info{
		display: flex; align-items: center; margin-top: 10px;

		@media (max-width: @t){margin-top: 5px;}
	}
	.cd-code{
		font-size: 14px; line-height: 1.4;
		.label{font-weight: 600;}
	}
	.cd-avarage-rate-section{
		display: flex; align-items: center; justify-content: flex-end; margin-left: 8px; padding-left: 9px; position: relative;
		&:before{.pseudo(1px,15px); background: @borderColor; left: 0; bottom: 1px;}

		@media (max-width: @m){
			&:before{bottom: 3px;}
		}
	}
	.cd-rate-average{padding-left: 7px; font-size: 14px; color: @textColor; font-weight: 600;}
	.cd-comments-link{
		padding-left: 7px; font-size: 14px; line-height: 1.4; color: @blue; font-weight: 600; text-decoration: underline; cursor: pointer;
		@media (min-width: @t){
			&:hover{text-decoration: none;}
		}

		@media (max-width: @t){
			&:hover{text-decoration: underline;}
		}
	}

	.cd-images{
		position: relative;

		@media (max-width: @m){padding-bottom: 15px;}
	}
	.cd-xxx-img-info{
		display: flex; align-items: center; justify-content: center; flex-direction: column; font-size: 20px; font-weight: 600; color: @textColor; position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 1; cursor: pointer;
		span{
			display: flex; justify-content: center; padding-top: 60px; position: relative;
			&:before{.pseudo(50px,50px); display: flex; align-items: center; justify-content: center; background: url(assets/images/hide.svg); background-size: contain; position: absolute; top: 0;}
		}

		@media (max-width: @m){
			font-size: 13px;
			span{
				padding-top: 33px;
				&:before{width: 30px; height: 30px;}
			}
		}
	}
	.cd-xxx-img-btn{
		display: flex; align-items: center; justify-content: center; height: 50px; margin: 20px 30px 0; padding: 5px 45px; background: @white; border: 1px solid @borderColor; font-size: 15px; font-weight: 600; color: @textColor; cursor: pointer; z-index: 11; .transition(all);
		&:hover{border-color: @red; color: @red;}

		@media (max-width: @t){
			margin: 0;
			&:hover{border-color: @borderColor; color: @textColor;}
		}
		@media (max-width: @m){margin-top: 10px; height: 35px; padding: 3px 10px;}
	}
	.cd-images-fallback{
		height: 640px; display: flex; align-items: center; justify-content: center; position: relative;
		&.xxx{
			filter: blur(25px); position: relative;
			&:before{.pseudo(auto,auto); top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(255,255,255,0.8); z-index: 1;}
		}

		@media (max-width: @l){height: 500px;}
		@media (max-width: @t){height: 400px;}
		@media (max-width: @m){height: 350px;}
		:deep(a:not(:first-child)){display: none;}
		:deep(a:first-child){
			height: 640px; display: flex; align-items: center; justify-content: center; position: relative;

			@media (max-width: @l){height: 500px;}
			@media (max-width: @t){height: 400px;}
			@media (max-width: @m){height: 350px;}
		}
		:deep(img){width: auto; height: auto; max-width: 100%; max-height: 100%;}
	}
	.cd-hero-image{
		height: 640px; display: flex; align-items: center; justify-content: center; position: relative;
		&.xxx{
			filter: blur(25px); position: relative;
			&:before{.pseudo(auto,auto); top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(255,255,255,0.8); z-index: 1;}
		}
		.swiper:not(.swiper-initialized) .swiper-slide:not(:first-child){overflow: hidden; height: 0; visibility: hidden;}

		@media (max-width: @l){height: 500px;}
		@media (max-width: @t){height: 400px;}
		@media (max-width: @m){height: 350px;}
	}
	.cd-no-image{
		height: 500px; display: flex; justify-content: center; align-items: center;
		img{width: auto; height: auto; max-width: 100%; max-height: 100%;}

		@media (max-width: @l){height: 350px;}
		@media (max-width: @t){height: 300px;}
		@media (max-width: @m){height: 250px;}
	}
	.cd-hero-slider{
		display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;
		:deep(.swiper){height: 100%;}
		:deep(.swiper-wrapper){align-items: center;}
		@media (max-width: @m){
			:deep(.swiper){margin: 0 15px;}
		}
		:deep(.swiper-pagination){
			display: none;

			@media (max-width: @m){
				display: flex; align-items: center; justify-content: center; flex-wrap: wrap; width: 100%; margin: 0; padding: 0 15px; list-style: none; position: absolute; top: auto; left: 50%; bottom: 0; right: auto; transform: translateX(-50%);line-height: 0; text-align: center; z-index: 11;
				.swiper-pagination-bullet{display: inline-block; flex-shrink: 0; margin: 0 4px; width: 12px; height: 12px; padding: 0; background: @borderColor; border-radius: 100%; font-size: 0; line-height: 0; position: relative; .transition(all);}
				.swiper-pagination-bullet-active{background: @blue;}
				span:only-child{display: none;}
			}
		}
	}
	.cd-hero-slide{
		display: flex!important; align-items: center; justify-content: center; text-align: center; cursor: pointer;
		:deep(div), :deep(a){display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;}
		:deep(img){width: auto; height: auto; max-width: 100%; max-height: 100%;}
	}
	.cd-hero-zoom{display: flex; align-items: center; background-repeat: no-repeat!important; background-size: contain!important; background-position: center!important; transition: transform 0.3s; position: absolute; top: 0; bottom: 0; right: 0; left: 0; cursor: crosshair; z-index: 1111;}

	.cd-thumbs-slider{
		margin: 20px auto 0; padding: 0 2px; position: relative;
		&.xxx{
			filter: blur(8px); position: relative;
			&:before{.pseudo(auto,auto); top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(255,255,255,0.8); z-index: 1;}
		}
		&.special{
			:deep(.swiper){flex-grow: 1;}
			:deep(.swiper-wrapper){justify-content: center;}
		}

		@media (max-width: @t){padding: 0 35px;}
		@media (max-width: @m){display: none!important;}
	}
	.cd-thumbs-fallback{
		@media (max-width: @m){display: none;}
	}
	.cd-thumb{
		display: flex; align-items: center; justify-content: center; height: 110px; border: 1px solid transparent; cursor: pointer; .transition(border-color);
		:deep(span){display: flex!important; align-items: center; justify-content: center; height: 110px;}
		:deep(img){width: auto; height: auto; max-width: 80%; max-height: 80%; display: block;}
		&.swiper-slide-thumb-active{
			border-color: @blue;
			&:hover{border-color: @blue;}
		}
		@media (min-width: @t){
			&:hover{border-color: @borderColor;}
		}
		@media (max-width: @l){
			height: 87px;
			:deep(span){height: 87px;}
		}
		@media (max-width: @t){
			height: 66px;
			:deep(span){height: 66px;}
		}
	}

	:deep(.cd-energy-info){
		display: flex; align-items: center; width: 100%; margin: 0 0 -1px; padding: 9px 0; border-top: 1px solid @borderColor; border-bottom: 1px solid @borderColor; position: relative;

		@media (max-width: @m) {width: calc(~'100% - -30px'); margin: 0 0 -1px -15px; padding: 10px 15px; }
	}
	:deep(.cd-energy) {
		display: flex; align-items: center; font-size: 15px; line-height: 1.4; color: @blue; font-weight: 600; text-decoration: none;
		img{display: block; margin-right: 12px; width: auto; height: auto; max-width: 70px; max-height: 26px;}
		span{position: relative;}
		&.link{
			cursor: pointer;
			span {
				padding-right: 15px;
				&:before {.icon-arrow-down(); font: 8px/8px @fonti; font-weight: 600; color: @blue; position: absolute; top: 7px; right: 0; .rotate(-90deg); .transition(right);}
			}
			@media (min-width: @t) {
				&:hover{
					color: @blue; text-decoration: underline;
					span:before{right: -5px;}
				}
			}
		}

		@media (max-width: @t) {
			img{margin-right: 10px; max-width: 65px; max-height: 24px;}
		}
	}
	.badge-bottom-left{
		display: flex; align-items: center; justify-content: center; width: auto; height: 40px; margin-right: 10px; padding: 0 15px; background: @blue; font-size: 16px; font-weight: bold; color: @white; text-decoration: none; position: absolute; left: 0; bottom: 0; z-index: 111; cursor: pointer; .transition(opacity);
		@media (min-width: @t){
			&:hover{opacity: 0.9;}
		}

		@media (max-width: @ms){height: 32px; margin-right: 5px; font-size: 14px; left: 15px; bottom: 20px;}
	}
	.btn-model-view{
		background: @blue;
		span{
			padding-left: 30px; position: relative;
			&:before{.pseudo(20px,20px); display: flex; align-items: center; justify-content: center; background: url("/images/cube.svg") no-repeat; background-size: cover; position: absolute; left: 0; top: 1px;}
		}
	}
	.btn-image-state{
		background: #CDD700;
		&.special{left: 155px;}
	}

	.cd-col2{
		flex-grow: 1; padding-top: 32px;

		@media (max-width: @m){padding-top: 17px;}
	}
	.cd-price-container{
		display: flex; align-items: flex-start; justify-content: space-between; flex-grow: 1; margin-bottom: 20px; position: relative;

		@media (max-width: @m){margin-bottom: 17px;}
	}

	.cd-brand{
		max-width: 110px; max-height: 45px; display: block; margin-left: 20px;
		:deep(a){max-width: 110px; max-height: 45px; display: flex; align-items: flex-start; justify-content: flex-end;}
		:deep(img){display: block; width: auto; height: auto; max-width: 110px; max-height: 45px;}

		@media (max-width: @l){
			max-width: 95px; max-height: 35px;
			:deep(a){max-width: 95px; max-height: 35px;}
			:deep(img){max-width: 95px; max-height: 35px;}
		}
		@media (max-width: @t){
			max-width: 90px; max-height: 30px;
			:deep(a){max-width: 90px; max-height: 30px;}
			:deep(img){max-width: 90px; max-height: 30px;}
		}
		@media (max-width: @m){
			max-height: 34px;
			:deep(a){max-height: 34px;}
			:deep(img){max-height: 34px;}
		}
	}

	.cd-conf-price-label{
		display: none; margin-bottom: 20px; padding-left: 25px; font-size: 14px; line-height: 1.2; color: @textColor; font-weight: 600; position: relative;
		&.active{display: block;}
		&:before{.icon-euro(); font: 17px/17px @fonti; color: @blue; position: absolute; left: 0;}
		p{padding-bottom: 0;}

		@media (max-width: @m){
			margin-bottom: 17px; padding-left: 26px; font-size: 15px;
			&:before{font-size: 19px; line-height: 19px; top: 1px;}
			span{display: none;}
		}
	}
	.cd-conf-price-btn{
		color: @blue; text-decoration: underline;
		&:hover{text-decoration: none;}

		@media (max-width: @t){
			&:hover{text-decoration: underline;}
		}
	}
	.cd-conf-price-section{
		display: grid; grid-template-columns: repeat(2, 1fr); grid-template-rows: auto; width: 100%; margin: 16px 0; font-size: 13px; line-height: 1.2; color: #E21937; font-weight: 600;

		@media (max-width: @ms){grid-template-columns: fit-content(40%) fit-content(60%) 1fr;}
	}
	.cd-conf-price{
		grid-area: 1 / 1 / 2 / 2; justify-self: start; display: flex; flex-direction: column; justify-content: center; flex-grow: 1;
		span{display: block;}
		.cd-current-price{
			display: flex; align-items: center; padding-top: 1px; font-size: 28px; line-height: 1.1; font-weight: 600; flex-shrink: 0;

			@media (max-width: @t){font-size: 26px;}
			@media (max-width: @m){flex-direction: column; align-items: flex-start;}
		}
	}
	.cd-conf-price-timer{grid-area: 1 / 1 / 2 / 3; justify-self: end; margin-left: 15px; position: relative;}
	.cd-conf-price-timer-bottom{
		display: flex; align-items: center;
		:deep(span){font-size: 21px; line-height: 1.1;}
		.countdown{flex-shrink: 0; display: block; padding-top: 1px;}
		:deep(.value){
			margin-left: 3px; padding-left: 8px; position: relative;
			&:before{.pseudo(1px,13px); background: @textColor; position: absolute; left: 0; bottom: 6px;}
		}
		:deep(.frame){color: @textColor;}
		:deep(.hours){
			margin: 0; padding: 0;
			&:before{content: none;}
		}

		@media (max-width: @m){
			:deep(span){font-size: 17px; line-height: 1.6;}
			:deep(.value){
				margin-left: 2px; padding-left: 7px;
				&:before{height: 11px; bottom: 5px;}
			}
			:deep(.hours){
				margin: 0; padding: 0;
				&:before{content: none;}
			}
		}
	}
	.cd-conf-price-remove{
		display: flex; align-items: center; justify-content: center; flex-shrink: 0; width: 22px; height: 22px; margin-left: 12px; background: @white; border: 1px solid @red; border-radius: 100%; font-size: 0; line-height: 0; text-decoration: none; position: relative; .transition(background);
		&:before{.icon-x(); font: 11px/11px @fonti; color: @red; font-weight: 600; text-indent: 1px; padding-top: 1px; .transition(color);}
		@media (min-width: @t){
			&:hover{
				background: @red; text-decoration: none;
				&:before{color: @white;}
			}
		}

		@media (max-width: @t){
			&:hover{text-decoration: none;}
		}
		@media (max-width: @m){
			margin-left: 7px;
			&:before{text-indent: 0;}
		}
	}
	.cd-dynamicprice-desc{
		display: none;
		&.active{display: block;}
		a{
			padding-right: 15px; text-decoration: none; position: relative;
			&:after{.icon-arrow-down(); font: 8px/8px @fonti; font-weight: 600; color: @blue; position: absolute; top: 6px; right: 0; .rotate(-90deg); .transition(right);}
			@media (min-width: @t){
				&:hover{
					text-decoration: underline;
					&:after{right: -5px;}
				}
			}
		}

		@media (max-width: @m){
			font-size: 13px;
			span{display: block;}
			&:before{top: -3px;}
		}
	}
	.cd-conf-price-note{
		grid-area: ~"2 / 1 / 3 / 3"; justify-self: start; display: block; width: 100%; margin-top: 10px; padding-left: 25px; font-size: 13px; font-weight: 600; color: @textColor; position: relative;
		&:before{.icon-info(); font: 17px/1 @fonti; color: @red; position: absolute; top: -1px; left: 0;}
	}

	.cd-return-policy{
		margin-top: 20px; padding-left: 29px; font-size: 14px; line-height: 1.4; position: relative;
		&:before{.icon-return(); font: 15px/15px @fonti; color: @textColor; position: absolute; top: 2px; left: 0;}

		@media (max-width: @m){margin: 20px auto 0;}
	}
	.cd-return-policy-link{
		display: inline-block; padding-right: 15px; font-weight: 600; text-decoration: none; color: @blue; cursor: pointer; position: relative;
		:deep(a){text-decoration: none;}
		&:before{.icon-arrow-down(); font: 8px/8px @fonti; font-weight: 600; color: @blue; position: absolute; top: 7px; right: 0; .rotate(-90deg); .transition(right);}
		@media (min-width: @t) {
			&:hover{
				text-decoration: underline; color: @blue;
				a{text-decoration: underline;color: @blue;}
				&:before{right: -5px;}
			}
		}
	}
	.cd-companies {
		&:before{.icon-briefcase(); font: 18px/18px @fonti; color: @textColor; position: absolute; top: 0; left: 0;}
		&.special{margin-top: 12px;}

		@media (max-width: @m) {
			&:before{top: 1px;}
		}
	}

	.cd-s-extra-info {
		display: flex; align-items: center; margin: 17px 30px 0; font-size: 12px; line-height: 15px; color: @inputTextColor; font-weight: 600; text-decoration: underline; cursor: pointer;
		span{
			display: block; padding-left: 22px; position: relative;
			&:before{.icon-info(); font: 14px/1 @fonti; color: @inputTextColor; position: absolute; left: 0;}
		}
		&:hover{text-decoration: none;}

		@media (max-width: @m) {
			display: block; justify-content: center; width: 100%; margin: 18px 0 0;
			span:before{margin-top: 1px;}
		}
	}

	.cd-related-title{
		display: block; font-size: 25px; font-weight: 600;

		@media (max-width: @m){padding-bottom: 12px; font-size: 20px;}
	}

	.cd-related-posts{
		background: #F0F2F4; padding: 75px 0 60px; margin-bottom: -1px;

		@media (max-width: @t){padding: 40px 0;}
		@media (max-width: @m){padding: 20px 0;}
	}
	.cd-related-post-slider{
		.pp{
			width: 100%; margin: 0; background: transparent; margin-bottom: 0;
			@media (min-width: @t){
				&:hover{background: @white; box-shadow: 0 8px 10px 0 rgba(1,61,112,0.15);}
			}
		}
		@media (max-width: @m){
			width: calc(~"100% - -30px"); margin: 0 0 0 -15px; opacity: 1; position: relative;
		}
	}

	.cd-fixed-bar{
		position: fixed; bottom: -200px; left: 0; right: 0; background: @white; box-shadow: 0 0 10px 0 rgba(51,51,51,0.15); z-index: 11111; .transition(all);
		.cd-bar-wrapper{display: flex; align-items: center; width: 820px; margin: 0 auto;}
		&.visible{transform: translate3d(0,-200px,0);}
		.cd-fixed-img{
			display: flex; align-items: center; justify-content: center; flex-shrink: 0; width: 70px; height: 70px; margin-right: 15px; order: 1;
			:deep(img){display: block; width: auto; height: auto; max-width: 70px; max-height: 70px;}
		}
		.cd-title{font-size: 14px; line-height: 1.4; max-width: 340px; margin-right: 50px; order: 2;}

		@media (max-width: @m){
			padding: 10px 15px;
			.cd-bar-wrapper{width: auto;}
			.cd-fixed-img, .cd-title{display: none;}
		}
	}


	.cd-related-products{
		padding: 0 0 35px;
		&.special{padding-top: 35px;}

		@media (max-width: @t){
			padding-bottom: 25px;
			&.special{padding-top: 25px;}
		}
	}
	.cd-related-products-slider{
		position: relative;
		:deep(.swiper-slide){width: auto; margin-right: 20px;}
		:deep(.swiper-button-prev), :deep(.swiper-button-next){top: 140px;}

		@media (max-width: @t) {
			:deep(.swiper-button-prev), :deep(.swiper-button-next){top: 90px;}
		}
		@media (max-width: @m) {
			width: calc(~'100% - -40px');margin: 0 0 0 -20px;
			:deep(.swiper-wrapper) {
				display: flex; padding: 0 0 0 20px; overflow-y: hidden; white-space: normal; position: relative;
				&::-webkit-scrollbar{display: none;}
				&::-webkit-scrollbar-thumb{display: none;}
			}
			:deep(.swiper-slide){flex-shrink: unset; width: 28%!important; min-width: 28%; margin-right: 20px; white-space: normal;}
		}
		@media (max-width: @ms) {
			width: calc(~'100% - -30px'); margin: 0 0 0 -15px;
			:deep(.swiper-wrapper){padding: 0 0 0 15px;}
			:deep(.swiper-slide){width: 40%!important; min-width: 40%;}
		}
	}
</style>

<style lang="less">
	.gallery-active{overflow: hidden;}

	.cd-related-post-slider{
		.splide__track{
			width: calc(~"100% - -50px"); margin-left: -25px; padding: 15px 25px 25px!important;
			&:before, &:after{.pseudo(15px, auto); background: @lightGray; top: 0; bottom: 0; left: 0; z-index: 1;}
			&:after{left: unset; right: 0;}
		}
		.splide__slide{display: flex;}
		.splide__arrow{top: 140px;}

		@media (max-width: @m){
			.splide__track{
				width: auto; margin-left: 0; padding: 0!important;
				&:before, &:after{content: none;}
			}
			.splide__list{
				display: flex!important; padding: 0 0 0 15px!important; overflow-y: hidden; white-space: normal; position: relative;
				&::-webkit-scrollbar{display: none;}
				&::-webkit-scrollbar-thumb{display: none;}
			}

			.splide__slide{min-width: 30%; width: 30%; margin: 0 20px 0 0; white-space: normal;}
		}
		@media (max-width: @ms){
			.splide__slide{min-width: 80%; width: 80%;}
		}
	}

	/*------- image zoom -------*/
	.iiz, .iiz__zoom-img{cursor: crosshair!important;}
	/*------- /image zoom -------*/
</style>
